import React, { MutableRefObject, useCallback, useEffect } from 'react';
import { useEventCallback } from '@mui/material';
import {
  CustomCommandExecutedEventArgs,
  DXR,
  RibbonTabType,
  RichEdit,
} from '../../../common/devexpress/RichEdit/dx-richedit';

export type CustomButtonProps = {
  richEdit: MutableRefObject<RichEdit>;
  tab: RibbonTabType;
  buttonId: string;
  text: string;
  icon?: string;
  onClick: (richEdit: RichEdit, args: CustomCommandExecutedEventArgs) => void;
};
/*
  Adds a button to RichEdit's Ribbon tab and handles clicks on it
 */
export const CustomButton: React.FC<CustomButtonProps> = (props) => {
  const { richEdit } = props;
  const commandExecutedEventHandler = useEventCallback(
    async (
      sender: RichEdit | undefined,
      args: CustomCommandExecutedEventArgs | undefined,
    ) => {
      if (!sender || !args) {
        return;
      }

      if (args.commandName === props.buttonId) {
        props.onClick(sender, args);
      }
    },
  );

  useEffect(
    function AddButton() {
      richEdit.current.updateRibbon((ribbon) => {
        if (!ribbon) return;
        const newFilePanel = ribbon.getTab(props.tab)!;
        newFilePanel.insertItem(
          new DXR.RibbonButtonItem(props.buttonId, props.text, {
            icon: props.icon,
            showText: true,
          }),
        );
      });
      richEdit.current.events.customCommandExecuted.addHandler(
        commandExecutedEventHandler,
      );

      return () => {
        if (richEdit.current?.isDisposed === false) {
          richEdit.current.events.customCommandExecuted.removeHandler(
            commandExecutedEventHandler,
          );
          richEdit.current.updateRibbon((ribbon) => {
            if (!ribbon) return;

            const panel = ribbon.getTab(props.tab);
            if (!panel) return;

            panel.removeItem(props.buttonId);
          });
        }
      };
    },
    [props.tab, props.buttonId, props.text],
  );

  return null;
};
